import { useQuery } from '@apollo/client';
import { useLocation, useSearchParams } from 'react-router-dom';

import CardChart from '../../../components/CardChart';
import { Spinner } from '../../../components';
import QueryErrorBoundary from '../../../components/error-handling';

import {
  FETCH_CORPORATE_BCP_LOCATIONS,
  FETCH_LOCATION_BCP_PA,
} from '../queries/RiskHub';

export function BcpLocationCard() {
  let [searchParams] = useSearchParams();
  const location = useLocation();
  const divisionUuid = searchParams.get('division');
  const locationUuid = searchParams.get('location');

  const pathname = location.pathname;
  const IS_LOCATION_RISK_HUB = pathname === '/location-risk-hub';

  const query = IS_LOCATION_RISK_HUB
    ? FETCH_LOCATION_BCP_PA
    : FETCH_CORPORATE_BCP_LOCATIONS;

  const { data, loading, error } = useQuery(query, {
    variables: {
      filter: IS_LOCATION_RISK_HUB ? { locationUuid } : { divisionUuid },
    },
  });

  const riskHubData = IS_LOCATION_RISK_HUB
    ? data?.bcpProcessAreaStatus
    : data?.bcpLocationStatus;

  if (loading)
    return (
      <div className="flex items-center justify-center p-6">
        <Spinner />
      </div>
    );

  return (
    <QueryErrorBoundary error={error}>
      <div className="rounded-[10px] border border-secondary-100 overflow-hidden relative min-h-min">
        <h2 className="text-sm text-primary-100 tracking-wider font-bold border-b border-secondary-100 bg-silver flex justify-center items-center">
          {IS_LOCATION_RISK_HUB
            ? 'Process Areas on MEO'.toUpperCase()
            : 'Locations on MEO'.toUpperCase()}
        </h2>
        <div className="h-[200px] py-3 flex flex-col justify-between items-center">
          <span className="font-bold text-center text-5xl text-blue tracking-wider">
            {IS_LOCATION_RISK_HUB
              ? riskHubData?.totalProcessAreas
              : riskHubData?.totalLocations}
          </span>
          <CardChart
            completed={riskHubData ? riskHubData.totalFinalized! : 0}
            inProgress={riskHubData ? riskHubData.totalInProgress! : 0}
            notStarted={riskHubData ? riskHubData.totalNotStarted! : 0}
            outdated={riskHubData ? riskHubData.totalOutdated! : 0}
            type="simplified"
          />
          <div className="text-primary-100 text-xsm text-center font-light tracking-wider">
            BCP Completed
          </div>
        </div>
      </div>
    </QueryErrorBoundary>
  );
}
